import { PositionsV3 } from '@src/containers/Blotters/PositionsV3';
import type { PositionsBlotterPanelConfig } from '@src/types/LayoutConfig';
import { MixpanelEventSource, MixpanelSourceProvider } from '@talos/kyoko';
import type { LayoutPanelProps } from '../../../types';
import { BlotterPanel } from './BlotterPanel';

export function PositionsPanel({ params, api }: LayoutPanelProps<PositionsBlotterPanelConfig>) {
  return (
    <MixpanelSourceProvider value={MixpanelEventSource.PositionsBlotter}>
      <BlotterPanel
        panelApi={api}
        panelTabs={params.tabs}
        panelBlottersState={params.blotterTablesState}
        data-testid="positions-blotter-panel"
      >
        <PositionsV3 />
      </BlotterPanel>
    </MixpanelSourceProvider>
  );
}
